import { IDexTrade } from "../interfaces/common";

/**
 * We may have duplicates, remove them
 * @param input
 * @returns
 */
export const removeTradesDuplicates = (input: IDexTrade[]): IDexTrade[] => {
  const result: IDexTrade[] = [];
  const hash: any = {};
  input.forEach((i: IDexTrade) => {
    const key = `${i.tx}-${i.date}`;
    if (!hash[key]) {
      hash[key] = 1;
      result.push(i);
    }
  });
  return result;
};
